import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'dashboard-v2-student-status',
  templateUrl: './student-status.component.html',
})
export class DashboardV2StudentStatusComponent implements OnChanges {
  @Input() activePercent = 0;
  @Input() items: any[] = [];

  readonly chartView: [number, number] = [120, 120];
  readonly chartScheme = { domain: ['#22c55e', '#ef4444', '#64748b'] };
  chartData: any[] = [];
  chartColors: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.updateChartData();
    }
  }

  private updateChartData(): void {
    const validItems = (this.items || []).filter((item: any) => this.toNumber(item.value) > 0);

    this.chartData = validItems.length
      ? validItems.map((item: any) => ({ name: item.label, value: this.toNumber(item.value) }))
      : [{ name: 'Sem dados', value: 1 }];

    this.chartColors = (this.items || []).map((item: any) => ({ name: item.label, value: item.color }));
    this.chartColors.push({ name: 'Sem dados', value: 'var(--layout-text-5)' });
  }

  get displayedActivePercent(): number {
    const total = (this.items || []).reduce((acc: number, item: any) => acc + this.toNumber(item.value), 0);
    const active = (this.items || []).find((item: any) => item.label === 'Ativos');

    return total > 0 && active
      ? Math.round((this.toNumber(active.value) / total) * 100)
      : this.toNumber(this.activePercent);
  }

  private toNumber(value: any): number {
    const parsed = Number(value);
    return isNaN(parsed) ? 0 : parsed;
  }
}
